import React, { useCallback, useEffect, useRef, useState } from "react";
import * as echarts from 'echarts';
import {
    dashboardApi,
    useGetTransactionForAllV2Query,
    useGetEnergyForAllV2Query,
    useGetTransactionForStationV2Query,
    useGetEnergyForStationV2Query
} from "services/dashboardService";
import { useSelector, useDispatch } from "react-redux";
import { rootReducerType } from "redux/combineReducers";

interface paramsProps {
    params: {
        startDate: string,
        endDate: string
    }
}

export default function Transaction({ params }: paramsProps) {
    const { startDate, endDate } = params;
    const detailsCharts = useRef<any>(null)
    const dispatch = useDispatch();
    const transactionsDashboard = useGetTransactionForAllV2Query(params).data;
    const energyDashboard = useGetEnergyForAllV2Query(params).data;
    const [myChart, setMyChart] = useState<any>(null)
    const { stationId } = useSelector(
        (state: rootReducerType) => state.stationIdReducer
    );
    let paramsStation = { stationId, startDate, endDate }
    const transactionsStationDashboard = useGetTransactionForStationV2Query(paramsStation, { skip: !stationId ? true : false }).data;
    const energyStationDashboard = useGetEnergyForStationV2Query(paramsStation, { skip: !stationId ? true : false }).data;


    useEffect(() => {
        if (!stationId) {
            dispatch(
                dashboardApi.endpoints.getTransactionForAllV2.initiate(
                    { startDate: params.startDate, endDate: params.endDate },
                    { subscribe: false, forceRefetch: true }
                )
            );
            dispatch(
                dashboardApi.endpoints.getEnergyForAllV2.initiate(
                    { startDate: params.startDate, endDate: params.endDate },
                    { subscribe: false, forceRefetch: true }
                )
            );
            if (detailsCharts.current) {
                if (!myChart) {
                    intCharts(transactionsDashboard, energyDashboard)
                } else {
                    updateCharts(myChart, transactionsDashboard, energyDashboard)
                }
            }
        }

    }, [stationId, startDate, endDate, transactionsDashboard, energyDashboard])

    useEffect(() => {
        if (stationId) {
            {
                dispatch(
                    dashboardApi.endpoints.getEnergyForStationV2.initiate(
                        { stationId, startDate: params.startDate, endDate: params.endDate },
                        { subscribe: false, forceRefetch: true }
                    )
                );
                dispatch(
                    dashboardApi.endpoints.getTransactionForStationV2.initiate(
                        { stationId, startDate: params.startDate, endDate: params.endDate },
                        { subscribe: false, forceRefetch: true }
                    )
                );
                if (detailsCharts.current) {
                    if (!myChart) {
                        intCharts(transactionsStationDashboard, energyStationDashboard)
                    } else {
                        updateCharts(myChart, transactionsStationDashboard, energyStationDashboard)
                    }
                }
            }
        }
    }, [stationId, startDate, endDate, transactionsStationDashboard, energyStationDashboard])

    const intCharts = (barData, lineData) => {
        let chartDom = detailsCharts.current;
        let myChart = echarts.init(chartDom);
        setMyChart(myChart)
        updateCharts(myChart, barData, lineData)
    }

    const updateCharts = (myChart, transactionData, energyData) => {
        type EChartsOption = echarts.EChartsOption;
        let option: EChartsOption;
        option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    }
                }
            },
            // toolbox: {
            //   feature: {
            //     dataView: { show: true, readOnly: false },
            //     magicType: { show: true, type: ['line', 'bar'] },
            //     restore: { show: true },
            //     saveAsImage: { show: true }
            //   }
            // },
            legend: {
              data: ['Sessions', 'Energy']
            },
            xAxis: [
                {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    axisPointer: {
                        type: 'shadow'
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    // name: 'Precipitation',
                    min: 0,
                    // max: 250,
                    // interval: 50,
                    axisLabel: {
                        formatter: '{value}'
                    }
                },
                {
                    type: 'value',
                    // name: 'Temperature',
                    min: 0,
                    // max: 25,
                    // interval: 5,
                    axisLabel: {
                        formatter: '{value}kWh'
                    }
                }
            ],
            series: [
                {
                    name: 'Sessions',
                    type: 'bar',
                    tooltip: {
                        valueFormatter: function (value) {
                            return (value as number) + ' ';
                        }
                    },
                    itemStyle: {
                        borderRadius: [10, 10, 0, 0], // 设置圆角半径，顺序是左上、右上、右下、左下
                    },
                    // barWidth: 20,
                    data: [
                        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
                    ]
                },
                {
                    name: 'Energy',
                    type: 'line',
                    smooth: true, // 启用平滑曲线
                    yAxisIndex: 1,
                    tooltip: {
                        valueFormatter: function (value) {
                            return (value as number) + ' kWh';
                        }
                    },
                    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                }
            ]
        };
        if (transactionData) {
            let transactionsDashboardKeys = Object.keys(transactionData)
            let transactionsDashboardValues = Object.values(transactionData)
            option.xAxis && (option.xAxis[0].data = transactionsDashboardKeys)
            option.series && (option.series[0].data = transactionsDashboardValues)
        }
        if (energyData) {
            let energyDashboardValues = Object.values(energyData)
            let energyDashboardValueData = energyDashboardValues.map((item: any) => {
                return item.energy
            })
            option.series && (option.series[1].data = energyDashboardValueData)
        }
        option && myChart.setOption(option);
    }

    // 创建事件处理函数
    const resizeChart = function () {
        if (myChart) {
            myChart.resize(); // 调整图表大小以适应新的窗口大小
        }
    };

    useEffect(() => {
        // 监听窗口大小变化事件
        window.addEventListener('resize', resizeChart)
        return () => {
            window.removeEventListener('resize', resizeChart);
        }
    }, [myChart])

    return (
        <div ref={detailsCharts} className="details-charts"></div>
    )
}
